import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './GlobalStyle';
//theme
import theme from '../../../src/theme';
// hooks
import { CreateFlowItem } from './injectables/atomics/CreateFlowItem';
// atomics
import { DependenciesNavigation } from './injectables/atomics/dependenciesNavigation';
import { DependenciesSearch } from './injectables/atomics/dependenciesSearch';
import { UserTopMenu } from './injectables/atomics/UserTopMenu';
import { ProductTopMenu } from './injectables/atomics/ProductTopMenu';
import addMapValuesDeep from 'deepdash';

import _ from 'lodash';
// @ts-ignore
addMapValuesDeep(_);

const renderInPortal = (component: React.ReactNode, destinationSelector: string) => {
    // console.log(document.querySelector(destinationSelector));
    if (document.querySelector(destinationSelector)) {
        return ReactDOM.createPortal(component, document.querySelector(destinationSelector) as Element);
    }
};

export const ReactInjectorApp = () => {
    return (
        <>
            <GlobalStyle />
            <DependenciesSearch />
            <CreateFlowItem />
            {renderInPortal(<DependenciesNavigation />, '#zApp')}
            {renderInPortal(<UserTopMenu />, '#z-user-top-menu')}
            {renderInPortal(<ProductTopMenu />, '#z-user-product-menu')}
        </>
    );
};
